// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xml:space='preserve'
    viewBox='0 15.27 295 264.46'
    ...attributes
  ><path
      d='M291.874 248.279 165.605 26.526c-4.007-7.037-10.776-11.26-18.107-11.26s-14.101 4.202-18.107 11.239L3.121 248.238c-3.979 6.989-4.164 15.013-.493 21.326s10.663 10.165 18.705 10.165h252.329c8.042 0 15.035-3.852 18.705-10.165 3.671-6.313 3.487-14.296-.493-21.285M146.665 86.229c9.665 0 17.5 7.835 17.5 17.5v63c0 9.665-7.835 17.5-17.5 17.5s-17.5-7.835-17.5-17.5v-63c0-9.665 7.835-17.5 17.5-17.5m.833 117.776c9.665 0 17.5 7.835 17.5 17.5s-7.835 17.5-17.5 17.5-17.5-7.835-17.5-17.5 7.835-17.5 17.5-17.5'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'Warning';
export default IconComponent;
